export default {"src":"/_next/static/media/calendar-check.19c920c4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};